module.exports = __webpack_public_path__ + "img/ilustra7.56546849.png";